import { Validator } from '@comparaonline/ui-forms-validators/dist/types/Validator';
import { PreInspectionFormStatus } from '../types';

export const preInspectionPlateCode = 'PREINSPECTION_INVALID_PLATE';

export const preInspectionPlate: Validator<string> = (_, __, meta) =>
  meta?.data?.preInspectionStatus === PreInspectionFormStatus.Invalid
    ? { errorCode: preInspectionPlateCode }
    : undefined;
